var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "url(#my_cash_svg__a)",
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 7.385a.185.185 0 00-.133-.05h-.99a1.866 1.866 0 00-.372-.794h1.35a.186.186 0 00.134-.05.168.168 0 00.052-.127v-.562a.168.168 0 00-.052-.127.186.186 0 00-.134-.05h-4.82a.186.186 0 00-.133.05.169.169 0 00-.052.127v.733c0 .048.018.09.056.124a.186.186 0 00.13.053h.84c.815 0 1.332.207 1.553.623H6.936a.186.186 0 00-.134.05.169.169 0 00-.052.127v.562c0 .05.018.094.052.126.035.034.079.05.134.05H9.41c-.086.301-.284.532-.594.69-.312.157-.722.236-1.231.236h-.65a.182.182 0 00-.13.053.165.165 0 00-.055.123v.701c0 .048.018.089.052.122.742.75 1.703 1.8 2.885 3.148a.171.171 0 00.146.067h1.13c.08 0 .136-.034.167-.1.038-.067.031-.128-.023-.187-1.128-1.316-2.014-2.302-2.66-2.955.657-.075 1.19-.277 1.6-.608.409-.33.657-.76.746-1.29h.974a.185.185 0 00.133-.05.168.168 0 00.052-.126v-.562a.168.168 0 00-.052-.127z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "my_cash_svg__a",
    x1: 7.44,
    y1: -7.777,
    x2: -8.114,
    y2: 9.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })))));
}
export default SvgMyCash;